// Imports
  // React
  import { useState, useContext } from 'react'
  // Context
  import { CartContext } from '../context/CartContext'
  // Icons
  import { BsFillCartDashFill, BsFillCartPlusFill } from "react-icons/bs";




//rafce

  const CartItemCardCounter = ({item, counter, stock}) => {
  
    // States
    const [count, setCount] = useState(counter);
    
    // Functions
    const { addItems, removeItems } = useContext(CartContext);

      // Remove functions
      const removeFromCart = (qty) => { 
        removeItems(item, qty);
      }
          
      const removeHandler = () => { 
        if (counter >= 1) {
          removeFromCart(1);
          setCount(count -1);
        }
      }
      
      // Add functions
      const addToCart = (qty) => { 
        addItems(item, qty);
      }

    const addHandler = () => { 
      if (stock > 0) {
        addToCart(1);
        setCount(count + 1);
        const CartWidgetCounter = document.getElementsByClassName('cartWidget-counter')[0];
        CartWidgetCounter.classList.remove('jello-horizontal');
        setTimeout(() => CartWidgetCounter.classList.add('jello-horizontal'), 50);
      }
    }

    return (
      <>
        <div className="cart-item-card-counter">
          <div className="item-card-counter-buttons">
            <div>
              <button onClick={ removeHandler }>
                <BsFillCartDashFill />
              </button>
            </div>
            <div className="item-card-counter-qty">
              {counter}
            </div>
            <div>
              <button onClick={ addHandler }>
                <BsFillCartPlusFill />
              </button>
            </div>
          </div>
          <div>
            <p style={ stock === 0 ? {color: 'red'} : {color: 'white'}}>
              disponible: {stock}
            </p>
          </div>
        </div>
      </>
    )
  }

  export default CartItemCardCounter